import { render, staticRenderFns } from "./StatsGrowth.vue?vue&type=template&id=a4011512&scoped=true&lang=pug"
import script from "./StatsGrowth.vue?vue&type=script&lang=js"
export * from "./StatsGrowth.vue?vue&type=script&lang=js"
import style0 from "./StatsGrowth.vue?vue&type=style&index=0&id=a4011512&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4011512",
  null
  
)

export default component.exports